import styled from "styled-components";
// 왼쪽 머리칸(div·subdiv) + 오른쪽 설명(text) 카드
const HeadedBox = ({ div, subdiv, text }) => {
  return (
    <Div>
      <div className="head">
        <div>{div}</div>
        <div>{subdiv}</div>
      </div>
      <div className="text">
        <div>{text}</div>
      </div>
    </Div>
  );
};
export default HeadedBox;
const Div = styled.div`
  display: flex;
  max-width: 65rem;
  border-radius: ${({ theme }) => theme.radius};
  border: 1px solid ${({ theme }) => theme.colors.line};
  background-color: white;
  overflow: hidden;
  & > .head {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;
    padding: 1.25rem 1rem;
    background: linear-gradient(160deg, ${({ theme }) => theme.colors.dark}, ${({ theme }) => theme.colors.ink});
    min-width: 11rem;
    text-align: center;
    & > div:first-child {
      font-weight: 700;
      color: white;
      font-size: 1.25rem;
    }
    & > div:last-child {
      font-size: 0.875rem;
      color: ${({ theme }) => theme.colors.foreground.highlightinverted};
    }
  }
  & > .text {
    display: flex;
    align-items: center;
    flex: 1;
    & > div {
      padding: 1.25rem 1.5rem;
      font-size: 1.05rem;
      line-height: 1.7;
      color: ${({ theme }) => theme.colors.monotone.dark};
    }
  }
  @media (max-width: 575px) {
    flex-direction: column;
    & > .head {
      min-width: 0;
    }
  }
`;
